module.exports = __webpack_public_path__ + "img/IMG_6984_L_Black.ca623ea3.jpg";